import React, { useState, useEffect } from 'react'

import { cloudinaryWidget } from 'Utils/cloudinary'

import Avatar from 'components/Avatar'
import Heading from 'components/Heading'
import Button from 'components/Button'

import styles from '../Signup.module.css'

const user_folder = process.env.NEXT_PUBLIC_CLOUDINARY_FOLDER_USER

const ChoosePhoto = ({ setValue, register, watch, handleSubmit, formField, isSubmitting, user }) => {
  const [error, setError] = useState()
  const { photo, email } = formField

  const email_value = watch(email.name)

  const value = watch(photo.name)
  const [picture, setPicture] = useState(value)

  const cloudinary_options = {
    resourceType: 'image',
    clientAllowedFormats: ['jpg', 'jpeg', 'gif', 'webp', 'avif', 'heif'],
    cropping: true,
    singleUploadAutoClose: true,
    croppingAspectRatio: 1 / 1,
    showSkipCropButton: false,
    folder: `${user_folder}/${email_value}`,
    tags: ['avatar'],
    uploadPreset: 'avatar',
    croppingValidateDimensions: true,
    minImageHeight: 500,
    minImageWidth: 500,
    maxImageHeight: 2500,
    maxImageWidth: 2500,
    maxImageFileSize: 50000000,
  }

  function handleUpload(err, result) {
    if (err) {
      setError(error.statusText)
    } else {
      setError(null)
    }

    if (result.event === 'success') {
      const response = result.info
      const uploaded_file = response.secure_url
      // console.log({ response })

      setPicture(uploaded_file)
    }
  }

  function setPhotoAndSubmit() {
    setValue(photo.name, picture)
    submit()
  }

  function submit() {
    setValue('step', 'photo')
    handleSubmit()
  }

  register(photo.name, photo?.validations)

  return (
    <div className={styles['step-wrapper']}>
      <Heading element="h3" bold center>{`Add a profile photo so people know it's you.`}</Heading>
      <div className={styles['choose-photo-wrapper']}>
        {!picture ? (
          <>
            <div className={styles['photo-wrapper']}>
              <Button
                onClick={() => cloudinaryWidget(cloudinary_options, handleUpload)}
                primary
                centered
                disabled={isSubmitting}
                spinner={isSubmitting}
              >
                Add A Photo
              </Button>
            </div>
            <div className={styles['form-footer']}>
              <Button onClick={submit} block primary={false} disabled={isSubmitting} spinner={isSubmitting}>
                Skip
              </Button>
            </div>
          </>
        ) : (
          <>
            <div className={styles['photo-wrapper']}>
              <div className={styles['photo-avatar']}>
                <Avatar image={picture} alt={`Profile Image`} />
              </div>

              <Button onClick={setPhotoAndSubmit} primary centered disabled={isSubmitting} spinner={isSubmitting}>
                Use This Photo
              </Button>
            </div>
            <div className={styles['form-footer']}>
              <Button onClick={submit} block primary={false} disabled={isSubmitting} spinner={isSubmitting}>
                Skip
              </Button>
            </div>
          </>
        )}

        {error && <div className={styles.error}>{error}</div>}
      </div>
    </div>
  )
}

export default ChoosePhoto
